module.exports = __webpack_public_path__ + "img/img91.66071236.png";